/* Odds Comfort: predictive search overlay.
   Layer 1 (instant): on-device fuzzy search over the catalog (typo tolerant, Arabic normalised, synonym aware).
   Layer 2: Shopify Predictive Search API for queries, collections and pages (and as a second opinion on products).
   Empty state: recent searches, trending, departments, personalised picks. */
(function () {
  'use strict';
  var Odds = window.Odds; if (!Odds) return;
  var $ = Odds.$, $$ = Odds.$$;
  var RKEY = 'odds:recent-searches';
  var root, input, side, main, foot, form, ctrl = null, seq = 0, active = -1;

  /* ---------- normalisation + matching ---------- */
  function norm(s) {
    return String(s || '').toLowerCase()
      .replace(/[ً-ْـ]/g, '')       // tashkeel, tatweel
      .replace(/[أإآ]/g, 'ا')   // alef variants
      .replace(/ى/g, 'ي')                 // alef maqsura -> ya
      .replace(/ة/g, 'ه')                 // ta marbuta -> ha
      .replace(/[^\p{L}\p{N}\s-]/gu, ' ')
      .replace(/-/g, '')                            // no-show -> noshow
      .replace(/\s+/g, ' ').trim();
  }
  var SYN = {
    sock: ['socks'], socks: ['sock'], shorab: ['socks'], شراب: ['socks'], جوارب: ['socks'], جورب: ['socks'], كلسات: ['socks'],
    men: ['mens', 'رجالي'], mens: ['men'], man: ['men'], رجالي: ['men'], رجال: ['men'], رجاليه: ['men'],
    women: ['womens', 'حريمي'], womens: ['women'], woman: ['women'], ladies: ['women'], lady: ['women'], حريمي: ['women'], نسائي: ['women'], نسائيه: ['women'], بناتي: ['women'],
    kids: ['kid', 'اطفال'], kid: ['kids'], children: ['kids'], child: ['kids'], boys: ['kids'], girls: ['kids'], school: ['kids'], اطفال: ['kids'], مدرسه: ['kids', 'school'],
    crew: ['long', 'طويل'], long: ['crew'], tall: ['crew'], طويل: ['crew'], طويله: ['crew'], كرو: ['crew'],
    quarter: ['quarter'], نص: ['quarter'], ankle: ['low', 'كاحل'], low: ['ankle'], كاحل: ['ankle'], قصير: ['ankle'], قصيره: ['ankle'], ربع: ['quarter'],
    noshow: ['invisible', 'hidden', 'مخفي'], invisible: ['noshow'], hidden: ['noshow'], liner: ['noshow'], مخفي: ['noshow'], مخفيه: ['noshow'],
    stripe: ['striped', 'مقلم'], striped: ['stripe'], stripes: ['stripe'], مقلم: ['stripe'], مقلمه: ['stripe'], خطوط: ['stripe'],
    dot: ['dots', 'منقط'], dots: ['dot'], dotted: ['dot'], منقط: ['dot'], منقطه: ['dot'],
    plain: ['solid', 'essentials', 'سادة'], solid: ['plain'], basic: ['essentials'], basics: ['essentials'], سادة: ['plain'],
    pack: ['pairs'], 5: ['5pack'], black: ['اسود'], اسود: ['black'], white: ['ابيض'], ابيض: ['white'], navy: ['كحلي', 'blue'], كحلي: ['navy'], grey: ['gray', 'رمادي'], gray: ['grey'], رمادي: ['grey'], pink: ['rose', 'وردي'], rose: ['pink'], وردي: ['rose', 'pink']
  };
  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], i, j; for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      var cur = [i], min = i;
      for (j = 1; j <= b.length; j++) { var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)); cur[j] = v; if (v < min) min = v; }
      if (min > max) return max + 1;
      prev = cur;
    }
    return prev[b.length];
  }
  function hay(p) {
    if (p._hay) return p._hay;
    var s = [p.t, p.ty, p.d, p.c, p.kw || '', (p.co || []).join(' '), Odds.deptLabel(p.d), Odds.cutLabel(p.c), p.pt, p.n + ' pairs pack ' + p.n + 'pack'].join(' ');
    p._hay = norm(s).split(' ').filter(Boolean);
    p._title = norm(p.t);
    return p._hay;
  }
  function tokenScore(tok, words) {
    var best = 0;
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      if (w === tok) best = Math.max(best, 3);
      else if (w.indexOf(tok) === 0) best = Math.max(best, 2.2);
      else if (tok.length > 2 && w.indexOf(tok) > -1) best = Math.max(best, 1.2);
      else if (tok.length >= 4) {
        var d = lev(tok, w.slice(0, Math.max(tok.length, 4)), tok.length >= 7 ? 2 : 1);
        if (d <= (tok.length >= 7 ? 2 : 1)) best = Math.max(best, d === 1 ? 1.2 : 0.8);
      }
    }
    return best;
  }
  function localSearch(q, limit) {
    var toks = norm(q).split(' ').filter(Boolean); if (!toks.length) return [];
    var out = [];
    Odds.catalog.items.forEach(function (p) {
      var words = hay(p), total = 0, ok = true;
      for (var i = 0; i < toks.length; i++) {
        var s = tokenScore(toks[i], words);
        if (!s && SYN[toks[i]]) SYN[toks[i]].forEach(function (alt) { s = Math.max(s, tokenScore(norm(alt), words) * 0.9); });
        if (!s) { ok = false; break; }
        total += s;
      }
      if (!ok) return;
      if (p._title.indexOf(norm(q)) > -1) total += 2;
      if (!p.a) total -= 1.5;
      out.push({ p: p, s: total });
    });
    out.sort(function (a, b) { return b.s - a.s || a.p.rank - b.p.rank; });
    return out.slice(0, limit || 8).map(function (o) { return o.p; });
  }
  Odds.search = { local: localSearch, norm: norm };

  /* ---------- recents ---------- */
  function recents() { return Odds.store.get(RKEY, []); }
  function pushRecent(q) {
    q = String(q || '').trim(); if (!q) return;
    var r = recents().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); r.unshift(q);
    Odds.store.set(RKEY, r.slice(0, 6));
  }

  /* ---------- rendering ---------- */
  function mark(text, q) {
    var t = Odds.esc(text), nq = Odds.esc(q.trim());
    if (!nq) return t;
    var i = t.toLowerCase().indexOf(nq.toLowerCase());
    return i < 0 ? t : t.slice(0, i) + '<mark>' + t.slice(i, i + nq.length) + '</mark>' + t.slice(i + nq.length);
  }
  function list(items) { return '<ul class="s-list" role="listbox">' + items.join('') + '</ul>'; }
  function qItem(q, icon, qq) { return '<li><button type="button" role="option" data-search-q="' + Odds.esc(q) + '"><svg class="icon" aria-hidden="true"><use href="#i-' + icon + '"/></svg><span>' + mark(q, qq || '') + '</span></button></li>'; }

  function idle() {
    var trend = (Odds.cfg.trending || []);
    var rec = recents();
    var html = '';
    if (rec.length) html += '<h5>' + Odds.t('search_recent') + '<button type="button" data-search-clear>' + Odds.t('search_clear') + '</button></h5>' + list(rec.map(function (q) { return qItem(q, 'clock'); }));
    html += '<h5 style="margin-top:' + (rec.length ? 22 : 0) + 'px">' + Odds.t('search_trending') + '</h5>' + list(trend.map(function (q) { return qItem(q, 'trend'); }));
    html += '<h5 style="margin-top:22px">' + Odds.t('search_departments') + '</h5><div class="s-chips">' +
      ['men', 'women', 'kids'].map(function (d) { var u = (Odds.cfg.deptUrls || {})[d]; return u ? '<a class="chip" href="' + u + '">' + Odds.deptLabel(d) + '</a>' : ''; }).join('') + '</div>';
    side.innerHTML = html;
    foot.innerHTML = '';
    Odds.catalog.load().then(function () {
      var rec2 = Odds.brain.recommend({ context: 'home', cartHandles: (Odds.cart && Odds.cart.state.handles) || [], n: 4 });
      var recent = Odds.brain.hasHistory() ? Odds.brain.recent(4) : [];
      var useItems = recent.length >= 2 ? recent : rec2.items;
      var title = recent.length >= 2 ? Odds.t('search_recent_viewed') : Odds.t('search_picked');
      main.innerHTML = '<h5><span><svg class="icon" aria-hidden="true" style="display:inline;width:14px;height:14px;vertical-align:-2px"><use href="#i-spark"/></svg> ' + Odds.esc(title) + '</span></h5><div class="s-results">' + useItems.map(function (p) { return Odds.render.searchCard(p); }).join('') + '</div>';
      Odds.emit('dom:updated');
    });
  }

  function paint(q, local, remote) {
    var haveCat = Odds.catalog.items.length > 0;
    var rprods = (remote && remote.products || []).filter(function (rp) { return !haveCat || Odds.catalog.byHandle[rp.handle]; });
    var prods = rprods.length ? rprods.map(function (rp) { return Odds.catalog.byHandle[rp.handle] || rp; }) : local;
    // keep strong local matches that the API missed (typos), after the API ones
    if (rprods.length) {
      local.forEach(function (p) { if (!prods.some(function (x) { return x.h === p.h || x.handle === p.h; })) prods.push(p); });
    }
    prods = prods.slice(0, 8);
    var s = '';
    var qs = (remote && remote.queries && remote.queries.length) ? remote.queries.map(function (x) { return x.text; }) : [];
    if (!qs.length) {
      var seen = {};
      local.slice(0, 4).forEach(function (p) { var lbl = Odds.deptLabel(p.d) + ' ' + Odds.cutLabel(p.c); if (!seen[lbl]) { seen[lbl] = 1; qs.push(lbl); } });
    }
    if (qs.length) s += '<h5>' + Odds.t('search_suggestions') + '</h5>' + list(qs.slice(0, 5).map(function (x) { return qItem(x, 'search', q); }));
    if (remote && remote.collections && remote.collections.length) s += '<h5 style="margin-top:22px">' + Odds.t('search_collections') + '</h5>' + list(remote.collections.slice(0, 4).map(function (c) { return '<li><a href="' + Odds.esc(c.url) + '"><svg class="icon" aria-hidden="true"><use href="#i-right"/></svg><span>' + Odds.esc(c.title) + '</span></a></li>'; }));
    if (remote && remote.pages && remote.pages.length) s += '<h5 style="margin-top:22px">' + Odds.t('search_pages') + '</h5>' + list(remote.pages.slice(0, 3).map(function (c) { return '<li><a href="' + Odds.esc(c.url) + '"><svg class="icon" aria-hidden="true"><use href="#i-right"/></svg><span>' + Odds.esc(c.title) + '</span></a></li>'; }));
    side.innerHTML = s;

    if (prods.length) {
      main.innerHTML = '<h5><span>' + Odds.t('search_products') + '</span></h5><div class="s-results">' + prods.map(function (p) { return Odds.render.searchCard(p); }).join('') + '</div>';
      foot.innerHTML = '<a class="btn" href="' + Odds.url('/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last') + '" data-search-all>' + Odds.t('search_view_all', { terms: Odds.esc(q) }) + '</a>';
    } else {
      main.innerHTML = '<div class="s-empty"><b>' + Odds.t('search_no_results', { terms: Odds.esc(q) }) + '</b><span>' + Odds.t('search_no_results_help') + '</span></div>';
      foot.innerHTML = '';
      Odds.catalog.load().then(function () {
        var rec = Odds.brain.recommend({ context: 'home', n: 4 });
        main.innerHTML += '<h5 style="margin-top:14px"><span>' + Odds.t('search_picked') + '</span></h5><div class="s-results">' + rec.items.map(function (p) { return Odds.render.searchCard(p); }).join('') + '</div>';
        Odds.emit('dom:updated');
      });
    }
    active = -1;
    Odds.emit('dom:updated');
  }

  /* ---------- querying ---------- */
  function run(q) {
    q = q.trim();
    var my = ++seq;
    if (!q) { if (ctrl) ctrl.abort(); idle(); return; }
    Odds.catalog.load().then(function () {
      if (my !== seq) return;
      var local = localSearch(q, 8);
      paint(q, local, null);
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      var url = Odds.cfg.routes.predictive + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,query,collection,page&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,tag,variants.title';
      fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (!j || my !== seq) return; paint(q, local, (j.resources && j.resources.results) || null); })
        .catch(function () { /* aborted or offline: keep local results */ });
    });
  }

  /* ---------- wiring ---------- */
  function openSearch(prefill) {
    root = root || $('#search-overlay'); if (!root) return;
    input = $('[data-search-input]', root); side = $('[data-search-side]', root); main = $('[data-search-main]', root); foot = $('[data-search-foot]', root); form = $('[data-search-form]', root);
    Odds.overlay.open(root, { focus: '[data-search-input]' });
    if (typeof prefill === 'string') input.value = prefill;
    run(input.value);
  }
  Odds.search.open = openSearch;

  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-search-open]');
    if (o) { e.preventDefault(); openSearch(); return; }
    if (!root || !root.contains(e.target)) return;
    var q = e.target.closest('[data-search-q]');
    if (q) { input.value = q.getAttribute('data-search-q'); input.focus(); run(input.value); return; }
    if (e.target.closest('[data-search-clear]')) { Odds.store.del(RKEY); idle(); return; }
    if (e.target.closest('[data-search-all]')) { pushRecent(input.value); if (Odds.brain) Odds.brain.track('search', { q: input.value }); return; }
    var card = e.target.closest('.res a');
    if (card && input.value) { pushRecent(input.value); if (Odds.brain) Odds.brain.track('search', { q: input.value }); }
  });
  document.addEventListener('input', function (e) { if (e.target && e.target.matches && e.target.matches('[data-search-input]')) run(e.target.value); });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-search-form]'); if (!f) return;
    var v = $('[data-search-input]', f).value.trim();
    if (v) { pushRecent(v); if (Odds.brain) Odds.brain.track('search', { q: v }); }
  });
  document.addEventListener('keydown', function (e) {
    var tag = (document.activeElement && document.activeElement.tagName) || '';
    var typing = /INPUT|TEXTAREA|SELECT/.test(tag) || (document.activeElement && document.activeElement.isContentEditable);
    if (((e.key === '/' && !typing) || ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k'))) { e.preventDefault(); openSearch(); return; }
    if (!root || !Odds.overlay.isOpen(root)) return;
    var items = $$('.s-list [role=option], .s-results .res > a', root);
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!items.length) return;
      e.preventDefault();
      active = e.key === 'ArrowDown' ? Math.min(items.length - 1, active + 1) : Math.max(-1, active - 1);
      items.forEach(function (it, i) { it.setAttribute('aria-selected', i === active ? 'true' : 'false'); });
      if (active > -1) { items[active].scrollIntoView({ block: 'nearest' }); } else input.focus();
    } else if (e.key === 'Enter' && active > -1 && items[active]) {
      e.preventDefault(); items[active].click();
    }
  });
  // warm the catalog on first interaction so search is instant
  ['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) { window.addEventListener(ev, function () { Odds.catalog.load(); }, { once: true, passive: true }); });
  setTimeout(function () { if (window.requestIdleCallback) requestIdleCallback(function () { Odds.catalog.load(); }); else Odds.catalog.load(); }, 1500);
})();
